<template>
  <div>
    <van-notify v-model="show" :type="type" color="#F15945" background="#FFFFFF">
      <div class="box">
        <div class="huisuiyunfont pop-up-icon">{{'\ue615'}}</div>
        <span>{{message}}</span>
      </div>
    </van-notify>
  </div>
</template>
<script>
import { Notify, Button } from 'vant'
export default {
  props: {
  },
  data () {
    return {
      show: false,
      message: '',
      type: ''
    }
  },
  methods: {
    showNotify () {
      this.show = true
      setTimeout(() => {
        this.show = false
      }, 2000)
    }
  },
  created () {
    // Notify({ type: 'danger', message: '通知内容' })
  },
  components: {
    [Notify.Component.name]: Notify.Component,
    [Button.name]: Button
  }
}
</script>
<style scoped lang="less" src="./style.less"></style>
